/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import controlledAccordionSectionStyle from "./controlledAccordionSectionStyle";
import ControlledAccordion from "../../../ControlledAccordion/ControlledAccordion";
import Typography from "@mui/material/Typography";
import TextContainer from "../../../Container/TextContainer";
import {Box} from "@mui/material";
import { AccordionContent } from "@/src/types/AccordionContent";

type ControlledAccordionSectionProps = {
  contentList: AccordionContent[];
  idPrefix: string;
  name: string;
  heading: string;
};

const ControlledAccordionSection = ({ contentList, idPrefix, name, heading }: ControlledAccordionSectionProps) => {
  return (
    <TextContainer>
      <Box sx={controlledAccordionSectionStyle.scrollToAnchor} id={idPrefix + "-accordion"} />
      <Typography variant={"h3"} component={"h2"} sx={controlledAccordionSectionStyle.headline}>
        {heading}
      </Typography>
      <ControlledAccordion contentList={contentList} idPrefix={idPrefix} name={name} />
    </TextContainer>
  );
};

export default ControlledAccordionSection;
